<template>
  <ValidationObserver ref="criminalConvictions">
    <div>
      <div class="mt-6">
        <div class="font-weight-bold mt-5 mb-1" v-if="!submitButtonTitle">
          Application Qualifications
        </div>
        <h2 class="mb-5">
          Do you have any unspent convictions, cautions, reprimands or warnings?
        </h2>
        <ValidationProvider v-slot="{ errors }" rules="required">
          <RadioButton
            :errorMessages="showValidationErrors ? errors : []"
            :selectedValue="unspentCriminalConvictions"
            v-model="unspentCriminalConvictions"
            @select="updateValue"
            :options="booleanOptions"
            showGroupInRow
          />
        </ValidationProvider>
        <div v-if="unspentCriminalConvictions" class="d-flex">
          <div class="nesting-spacer" />
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            class="flex-grow-1"
          >
            <v-textarea
              :label="`Please provide details ${!isMobile ? 'of your  ' : ''}`"
              v-model="details"
              :error-messages="showValidationErrors ? errors : []"
              height="200"
            />
          </ValidationProvider>
        </div>
        <p class="font-italic my-5">{{ footerText }}</p>
      </div>
      <div class="d-flex justify-end">
        <PrimaryButton @click.native="nextStep" :loading="isEditingUserDetails">
          {{ submitButtonTitle || "Continue" }}
        </PrimaryButton>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { EDIT_USER } from "@/store/modules/users/actions";
import { copyState } from "@/utils/helpers";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import {
  BOOLEAN_OPTIONS,
  CRIMINAL_CONVICTIONS_OPTIONS,
  CRIMINAL_CONVICTIONS_FOOTER_TEXT
} from "@/constants/workers";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import RadioButton from "@/components/common/RadioButton";
import { isBoolean } from "lodash";
import { GET_USER_DATA } from "@/store/modules/auth/getters";

const { mapGetters } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapState: mapUserState, mapActions } = createNamespacedHelpers(
  USERS_NAMESPACE
);

export default {
  name: "Qualifications",
  components: {
    PrimaryButton,
    ValidationProvider,
    ValidationObserver,
    RadioButton
  },
  props: {
    submitButtonTitle: String
  },
  created() {
    this.emitProgressValue(100);
    if (this.self.unspentCriminalConvictions) {
      this.unspentCriminalConvictions = Boolean(
        this.self.unspentCriminalConvictions
      );
    }
    this.details = this.self.unspentCriminalConvictions;
  },
  data() {
    return {
      booleanOptions: BOOLEAN_OPTIONS,
      criminalConvictions: CRIMINAL_CONVICTIONS_OPTIONS,
      footerText: CRIMINAL_CONVICTIONS_FOOTER_TEXT,
      showValidationErrors: false,
      unspentCriminalConvictions: null,
      details: null
    };
  },
  computed: {
    ...mapUserState(copyState(["isEditingUserDetails"])),
    ...mapGetters({
      self: GET_USER_DATA
    })
  },
  methods: {
    ...mapActions({
      editUser: EDIT_USER
    }),
    updateValue(val) {
      if (!val) {
        this.details = null;
      }
      this.unspentCriminalConvictions = val;
    },
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.criminalConvictions.validate();
      if (isValid) {
        if (isBoolean(this.unspentCriminalConvictions)) {
          await this.editUser({
            id: this.self.id,
            data: {
              unspentCriminalConvictions: this.details
            }
          });
        }
        this.showValidationErrors = false;
        this.emitProgressValue(101);
        this.$emit("close");
      }
    },
    emitProgressValue(value) {
      this.$emit("onStepChanged", {
        progressValue: value
      });
    },
    stepBack() {
      this.emitProgressValue(0);
    }
  }
};
</script>

<style lang="scss">
.nesting-spacer {
  background-color: $secondary-line;
  width: 5px;
  border-bottom: 5px solid $secondary-line;
  margin: 0 30px;
  height: auto;
}
</style>
